import { City } from '../../common/address/City';
import { Country } from '../../common/address/Country';
import { PostalCode } from '../../common/address/PostalCode';
import { Region } from '../../common/address/Region';
import { StreetAddress } from '../../common/address/StreetAddress';
import { StreetAddress2 } from '../../common/address/StreetAddress2';
export const RegisteredAddress = {
    city: City,
    country: Country,
    postal_code: PostalCode,
    region: Region,
    street_address: StreetAddress,
    street_address2: StreetAddress2,
};
